import { ChevronRightIcon } from '@hermes/web-components'
import addRtlProperty from '../../utils/addRtlProperty'

const ChevronRight = addRtlProperty(ChevronRightIcon)

export default ChevronRight
